define('OutSystems/ClientRuntime/modules/Database/Common/Database',["require", "exports", "tslib", "../../../Exceptions"], function (require, exports, tslib_1, Exceptions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Database = (function () {
        function Database(databaseName) {
            this.databaseName = databaseName;
            this.isInitialized = false;
            this.allInitializers = [];
            this.initializersToRun = [];
        }
        Object.defineProperty(Database.prototype, "name", {
            get: function () {
                return this.databaseName;
            },
            enumerable: false,
            configurable: true
        });
        Database.prototype.registerInitializer = function (initializer) {
            if (this.isInitialized) {
                throw new Exceptions_1.Exceptions.DataBaseException("", "Cannot register a database initializer on the already initialized database '" + this.name + "'");
            }
            this.allInitializers.push(initializer);
        };
        Database.prototype.initialize = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.isInitialized) {
                                throw new Exceptions_1.Exceptions.DataBaseException("", "Cannot initialize the already initialized database '" + this.name + "'");
                            }
                            this.markInitialized();
                            return [4, this.identifyNeededInitializers()];
                        case 1:
                            _a.sent();
                            return [4, this.runNeededInitializers()];
                        case 2:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        Database.prototype.initializerCleanup = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.isInitialized) {
                                throw new Exceptions_1.Exceptions.DataBaseException("", "Cannot perform database initializer cleanup on the non-initialized database '" + this.name + "'");
                            }
                            return [4, this.cleanupNeededInitializers()];
                        case 1:
                            _a.sent();
                            return [2];
                    }
                });
            });
        };
        Database.prototype.identifyNeededInitializers = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.allInitializers && this.allInitializers.length > 0)) return [3, 2];
                            return [4, this.executeReadTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var _i, _a, initializer;
                                    return tslib_1.__generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                _i = 0, _a = this.allInitializers;
                                                _b.label = 1;
                                            case 1:
                                                if (!(_i < _a.length)) return [3, 4];
                                                initializer = _a[_i];
                                                return [4, initializer.isNeeded(tx)];
                                            case 2:
                                                if (_b.sent()) {
                                                    this.initializersToRun.push(initializer);
                                                }
                                                _b.label = 3;
                                            case 3:
                                                _i++;
                                                return [3, 1];
                                            case 4: return [2];
                                        }
                                    });
                                }); })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            this.releaseUnneededInitializers();
                            return [2];
                    }
                });
            });
        };
        Database.prototype.runNeededInitializers = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.initializersToRun.length > 0)) return [3, 2];
                            return [4, this.executeUpgradeTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var _i, _a, initializer;
                                    return tslib_1.__generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                _i = 0, _a = this.initializersToRun;
                                                _b.label = 1;
                                            case 1:
                                                if (!(_i < _a.length)) return [3, 4];
                                                initializer = _a[_i];
                                                return [4, initializer.run(tx)];
                                            case 2:
                                                _b.sent();
                                                _b.label = 3;
                                            case 3:
                                                _i++;
                                                return [3, 1];
                                            case 4: return [2];
                                        }
                                    });
                                }); })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        Database.prototype.cleanupNeededInitializers = function () {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.initializersToRun.length > 0)) return [3, 2];
                            return [4, this.executeUpgradeTransaction(function (tx) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                    var _i, _a, initializer;
                                    return tslib_1.__generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0:
                                                _i = 0, _a = this.initializersToRun;
                                                _b.label = 1;
                                            case 1:
                                                if (!(_i < _a.length)) return [3, 4];
                                                initializer = _a[_i];
                                                if (!initializer.cleanup) return [3, 3];
                                                return [4, initializer.cleanup(tx)];
                                            case 2:
                                                _b.sent();
                                                _b.label = 3;
                                            case 3:
                                                _i++;
                                                return [3, 1];
                                            case 4: return [2];
                                        }
                                    });
                                }); })];
                        case 1:
                            _a.sent();
                            this.releaseNeededInitializers();
                            _a.label = 2;
                        case 2: return [2];
                    }
                });
            });
        };
        Database.prototype.markInitialized = function () {
            this.isInitialized = true;
        };
        Database.prototype.releaseUnneededInitializers = function () {
            this.allInitializers = [];
        };
        Database.prototype.releaseNeededInitializers = function () {
            this.initializersToRun = [];
        };
        return Database;
    }());
    exports.default = Database;
});
//# sourceMappingURL=Database.js.map;
